import React, { useContext, useState, useEffect, useCallback } from 'react';
import { AuthContext } from '../context/AuthContext';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import axios from 'axios';
import Pagination from '../components/Pagination';
import './Dashboard.css';

const ApiLogs = () => {
  const { user, token } = useContext(AuthContext);
  const [logs, setLogs] = useState([]);
  
  // Estado para paginación
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [filters, setFilters] = useState({
    startDate: '',
    endDate: '',
    cupl: ''
  });

  const fetchLogs = useCallback(async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/payment-logs`, {
        params: filters,
        headers: { Authorization: `Bearer ${token}` }
      });
      setLogs(response.data);
    } catch (error) {
      console.error('Error al cargar logs:', error);
    }
  }, [token, filters]);

  useEffect(() => {
    fetchLogs();
  }, [fetchLogs]);

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  // Lógica de paginación
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = logs.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (items) => {
    setItemsPerPage(items);
    setCurrentPage(1);
  };

  // Resetear página cuando cambien los filtros
  useEffect(() => {
    setCurrentPage(1);
  }, [filters]);

  return (
    <div className="app-layout">
      <Sidebar userRole={user?.role} />

      <div className="main-content">
        <Navbar title="📜 Historial Permanente de Pagos API" />

        <div className="page-content">
          <div className="page-header">
            <div className="header-title">
              <h2>Filtros de Búsqueda</h2>
              <p className="subtitle">Consulta el historial de interacciones con la API del RUNT</p>
            </div>
          </div>

          {/* Sección de Filtros */}
          <div className="filters-bar" style={{ marginBottom: '20px' }}>
            <div className="filter-group">
              <label>📅 Desde:</label>
              <input 
                type="date" 
                name="startDate" 
                value={filters.startDate} 
                onChange={handleFilterChange}
              />
            </div>
            <div className="filter-group">
              <label>📅 Hasta:</label>
              <input 
                type="date" 
                name="endDate" 
                value={filters.endDate} 
                onChange={handleFilterChange}
              />
            </div>
            <div className="filter-group">
              <label>📄 CUPL:</label>
              <input 
                type="text" 
                name="cupl" 
                placeholder="Buscar CUPL..."
                value={filters.cupl} 
                onChange={handleFilterChange}
              />
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button 
                onClick={fetchLogs} 
                className="btn-primary"
              >
                🔍 Filtrar
              </button>
              <button 
                onClick={() => setFilters({ startDate: '', endDate: '', cupl: '' })} 
                className="btn-secondary"
              >
                🔄 Limpiar
              </button>
            </div>
          </div>

          <div className="table-section">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <div>
                <h2>📊 Registro de Peticiones RUNT</h2>
                <p style={{ color: 'var(--text-secondary)', fontSize: '14px', marginTop: '5px' }}>
                  Este log es permanente y se guarda en la base de datos central.
                </p>
              </div>
            </div>

          <div className="table-wrapper">
            <div className="table-responsive">
              <table className="users-table">
              <thead>
                <tr>
                  <th>Fecha/Hora</th>
                  <th>CUPL</th>
                  <th>Usuario</th>
                  <th>Acción</th>
                  <th>Detalle / Respuesta</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map(log => (
                  <tr key={log.id}>
                    <td>{new Date(log.created_at).toLocaleString()}</td>
                    <td><strong style={{ color: 'var(--primary-color)' }}>{log.cupl_number}</strong></td>
                    <td>{log.username || 'Sistema'}</td>
                    <td>
                      <span className={`status ${log.status === 'success' ? 'paid' : log.status === 'error' ? 'expired' : 'warning'}`}>
                        {log.action_type}
                      </span>
                    </td>
                    <td style={{ fontSize: '12px', color: log.status === 'error' ? 'var(--error-color)' : 'var(--text-secondary)' }}>
                      {log.detail}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
            
            <Pagination 
              currentPage={currentPage}
              totalItems={logs.length}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleItemsPerPageChange}
            />
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApiLogs;
